export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Bold.c1aca089.woff";